import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import type { JSX } from "react";

const faqs = [
    {
        title: "How does Talentir offer zero-fee payouts? Are there any hidden costs?",
        content:
            "Our advanced payment engine allows you to receive 100% of your earnings without any fees. We leverage cutting-edge technology to eliminate traditional transaction costs, ensuring there are no hidden charges. What you earn is exactly what you receive—the only difference is that it is faster, more transparent, and easy to share with hundreds or thousands of people.",
    },
    {
        title: "Can I leave or opt out of the Talentir service at any time?",
        content: "Yes, you are in full control at any given time.",
    },
    {
        title: "What is automated tax optimization, and how can it reduce my taxes?",
        content:
            "Automated tax optimization is not possible for every channel. Depending on your location, audience, content, and settings, we do our best to help you retain more income.",
    },
    {
        title: "Can I choose how I receive my payouts?",
        content:
            "Absolutely! We offer flexible payout options to suit your preferences. You can receive payments in stablecoins like USDC for ultra-low fees or traditional bank transfers. The choice is yours.",
    },
    {
        title: "How does real-time payout work?",
        content:
            "Our real-time payout system lets you watch your earnings flow into your account by the second. This feature provides immediate access to your funds, enhancing transparency and giving you control over your revenue like never before.",
    },
    {
        title: "What is the Talentir Brand Deal Universe?",
        content:
            "Working with the world's biggest influencer agencies, our clients have direct access to exclusive marketing campaigns from some of the biggest brands, projects, and protocols. By onboarding your channels, you unlock opportunities for brand collaborations through our network, constantly searching for the best advertising partners.",
    },
    {
        title: "What is the blockchain and why do you use it?",
        content:
            'Forget about complex terms like "blockchain" or "smart contracts"—what matters is providing a seamless, transparent, and self-executing backend that simplifies your life. With just one click, you can distribute payments to unlimited partners (we currently handle up to one million shareholders per asset) with precision and without human error. This unmatched efficiency gives you peace of mind that your earnings are managed in an automated, scalable, and completely transparent way.',
    },
    {
        title: "Can Talentir also help agencies, labels, and distributors?",
        content:
            "Yes, Talentir offers specialized solutions for agencies, labels, and distributors. We provide white-label stablecoin payment integrations, secure rights management, hassle-free distribution to unlimited rightsholders, and automated brand deal fulfillment to scale your operations efficiently.",
    },
    {
        title: "Can Talentir manage payments to multiple rightsholders?",
        content:
            "Yes, our platform simplifies rights management by allowing you to effortlessly manage payments to unlimited rightsholders. This process is fully automated and transparent, eliminating the need for spreadsheets and manual calculations.",
    },
    {
        title: "What are stablecoins, and why should I consider them for payouts?",
        content:
            "Stablecoins are cryptocurrencies pegged to stable assets like the US dollar, reducing volatility. Receiving payouts in stablecoins like USDC offers ultra-low fees and faster transaction times than traditional banking systems, which is especially beneficial for international transfers.",
    },
];

export function Faq(): JSX.Element {
    return (
        <section className="px-4 py-32">
            <p className="font-bold text-accent-flashy text-sm uppercase">FAQ</p>
            <h2 className="mt-6 font-bold text-4xl md:text-5xl">All you need to know</h2>
            <div className="mt-10">
                <Accordion type="single" collapsible className="w-full">
                    {faqs.map(({ title, content }, index) => (
                        <AccordionItem key={index} value={title}>
                            <AccordionTrigger className="text-left text-base">{title}</AccordionTrigger>
                            <AccordionContent className="text-muted-foreground">{content}</AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    );
}
